import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-display-profile',
  templateUrl: './display-profile.component.html',
  styleUrls: ['./display-profile.component.scss']
})

export class DisplayProfileComponent {
  profileForm: FormGroup = this.formBuilder.group({});
  ImageTypePhoto: any;
  PhotoFile: any;
  userId: number = 0;
  AdminRoleList: any = [];
  ProfilePhoto: any;
  UserProfileData: any;
  errorMessage: any = [];
  commonConstant: any = [];
  constructor(private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private storageService: StorageService,
    private sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.errorMessage = commonErrorMessage;
    this.commonConstant = CommonConstant;
    this.userId = Number(this.storageService.getValue('userId'));
    this.sharedService.setData('Profile');
    this.onInitProfileForm();
    this.getProfileDetail();
  }

  onInitProfileForm() {
    this.profileForm = this.formBuilder.group({
      FirstName: [{ value: '', disabled: true }, [Validators.required]],
      LastName: [{ value: '', disabled: true }, [Validators.required]],
      PhoneNo: [{ value: '', disabled: true }, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      Photo: [{ value: '', disabled: true },],
      EmailId: [{ value: '', disabled: true }],
      UserRole: [{ value: '', disabled: true }]
    });
  }

  get profileFormControl() {
    return this.profileForm.controls;
  }

  getProfileDetail() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.Profile.GetProfile.replace("{id}", this.userId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.UserProfileData = data.data;
        if (data.data.photo) {
          (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", data.data.photo);
        }
        else {
          (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", "assets/img/default_img.jpg");
        }
        this.spinner.hide();
        this.setProfileForm(data.data);
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getProfileDetail-Error', err);
      }
    });
  }

  setProfileForm(data: any) {
    this.profileForm.setValue({
      FirstName: data.firstName,
      LastName: data.lastName,
      PhoneNo: data.mobileNo,
      Photo: data.photo ? data.photo : '',
      EmailId: data.emailId,
      UserRole: data.adminRoleName,
    });
  }

  onCancel() {
    if (localStorage.getItem("adminRoleId") == "2") {
      this.router.navigate(['/student']);
    }
    else {
      this.router.navigate(['/user']);
    }
  }

  onEdit() {
    this.router.navigate(['/edit-profile']);
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Invalid Image", "Please select only JPG or PNG Image");
          (<HTMLInputElement>document.getElementById('uploadUserImage')).value = "";
          return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.ProfilePhoto = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", "assets/img/default_img.jpg");
      this.ProfilePhoto = null;
      (<HTMLInputElement>document.getElementById('uploadUserImage')).value = '';
      this.profileForm.controls['Photo'].setValue('');
      this.profileForm.patchValue({
        Photo: '',
      });
    }
  }
}
